export interface FormicaTimePickerDate {
  label?: string;
  value: Date | 'Now' | 0 | null;
  type?: FormicaTimePickerType;
  round?: boolean;
}

export type FormicaTimePickerType = 'Relative' | 'Absolute' | 'Quick' | 'Now';
export type CalendarContentTab = 'absolute' | 'relative' | 'now';
export type DatePickerSelectType = 'QUICK' | 'DEFAULT';

export interface RecentlyUsedDate {
  startDate: FormicaTimePickerDate;
  endDate: FormicaTimePickerDate;
}

export interface QuickDate {
  startDate: FormicaTimePickerDate;
  endDate: FormicaTimePickerDate;
}

export enum QuickDateTypes {
  // MINUTES
  THIS_MINUTE = 'THIS_MINUTE',
  LAST_MINUTE = 'LAST_MINUTE',
  LAST_15_MINUTES = 'LAST_15_MINUTES',
  LAST_30_MINUTES = 'LAST_30_MINUTES',
  LAST_60_MINUTES = 'LAST_60_MINUTES',
  // HOURS
  THIS_HOUR = 'THIS_HOUR',
  LAST_HOUR = 'LAST_HOUR',
  LAST_6_HOUR = 'LAST_6_HOUR',
  LAST_12_HOUR = 'LAST_12_HOUR',
  LAST_24_HOUR = 'LAST_24_HOUR',
  // DATES
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAY = 'LAST_7_DAY',
  LAST_15_DAY = 'LAST_15_DAY',
  LAST_30_DAY = 'LAST_30_DAY',
  // WEEKS
  THIS_WEEK = 'THIS_WEEK',
  LAST_WEEK = 'LAST_WEEK',
  // MONTHS
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  LAST_12_MONTHS = 'LAST_12_MONTHS',
  // YEARS
  THIS_YEAR = 'THIS_YEAR',
  LAST_YEAR = 'LAST_YEAR',
}
